import type { PurchaseOrderStage } from '../../../services/purchaseOrders';

export interface PurchaseOrderStageFilters {
    fulfillmentStatus: string[];
    billingStatus: string[];
    needsAttention: boolean;
}

// The exact filter combination each card represents; cards and the "More
// filters" dropdowns write these same three fields as one source of truth.
const STAGE_FILTERS: Record<PurchaseOrderStage, PurchaseOrderStageFilters> = {
    all: { fulfillmentStatus: [], billingStatus: [], needsAttention: false },
    awaitingShipment: {
        fulfillmentStatus: ['not_shipped'],
        billingStatus: [],
        needsAttention: false
    },
    awaitingInvoice: {
        fulfillmentStatus: [],
        billingStatus: ['not_billed'],
        needsAttention: false
    },
    needsAttention: { fulfillmentStatus: [], billingStatus: [], needsAttention: true },
    complete: { fulfillmentStatus: ['shipped'], billingStatus: ['billed'], needsAttention: false }
};

export function purchaseOrderStageFilters(stage: PurchaseOrderStage): PurchaseOrderStageFilters {
    return STAGE_FILTERS[stage];
}

function sameOptions(a: string[], b: string[]): boolean {
    return a.length === b.length && a.every((value) => b.includes(value));
}

// Returns null when the current filters match no card - a valid state (e.g.
// `shipped` + `not_billed` picked by hand), not a bug to paper over.
export function derivePurchaseOrderStage(
    current: PurchaseOrderStageFilters
): PurchaseOrderStage | null {
    const stages = Object.keys(STAGE_FILTERS) as PurchaseOrderStage[];
    return (
        stages.find((stage) => {
            const filters = STAGE_FILTERS[stage];
            return (
                sameOptions(filters.fulfillmentStatus, current.fulfillmentStatus) &&
                sameOptions(filters.billingStatus, current.billingStatus) &&
                filters.needsAttention === current.needsAttention
            );
        }) ?? null
    );
}
